<template>
  <div>
    <validation-provider
      :name="name"
      :rules="this.validations"
      v-slot="{ errors }"
    >
      <template
        v-if="hasAvailabledMdField(type)"
        class="has-availabled-field-invalid"
      >
        <slot :errors="errors"></slot>
      </template>
      <md-field v-else :class="[{ 'md-invalid': !!errors }, fieldClass]">
        <slot></slot>
        <span class="md-error" :class="{ 'top-110': isTextArea }">{{
          errors[0]
        }}</span>
      </md-field>
    </validation-provider>
  </div>
</template>

<script>
export default {
  name: "validation-field",
  props: ["validations", "name", "fieldClass", "type", "isTextArea"],

  computed: {},
  methods: {
    hasAvailabledMdField(type) {
      return [
        "date-picker",
        "date-range",
        "date-time-picker",
        "autocomplete",
        "multi-select",
        "time-picker",
        "select-filter"
      ].includes(type);
    }
  }
};
</script>

<style lang="scss" scoped>
.md-error {
  // bottom: -7px !important;
  top: 37px !important;
}
.top-110 {
  top: 110px !important;
}
</style>
